<route>
{
    "name": "media-manager",
    "meta": {
        "title": "Media Manager",
        "requiresAuth": true,
        "permission": "guest",
        "fail": "/404"
    }
}
</route>
<template>
  <company-layout>
      <v-container fluid>
          <app-media-manager prefix="/api/media-manager/"></app-media-manager>
      </v-container>
  </company-layout>
</template>

<script>
import CompanyLayout from "Layouts/Company.vue";
import AppMediaManager from 'Components/media-manager/MediaManager'

export default {
    components: {
        CompanyLayout,
        AppMediaManager
    }
};
</script>
